import { Link } from "@inertiajs/react"
import { useIntl } from "react-intl"
import { Button } from "@/components/ui/button"

/** Shown where official content would be, for people who haven't unlocked a program. */
export function UnlockPrompt({ what }: { what: string }) {
  const intl = useIntl()
  return (
    <div className="callout mt-4">
      <p>{intl.formatMessage({ id: "unlock.body" }, { what })}</p>
      <Button asChild variant="secondary" size="sm" className="mt-3">
        <Link href="/profile/programs">{intl.formatMessage({ id: "unlock.cta" })}</Link>
      </Button>
    </div>
  )
}
